export default __webpack_public_path__ + "static/media/Montserrat-Bold.b8c6bf23.woff2";